import React, { useEffect } from 'react'
import { pageTitle } from '../../helper'
import Cta from '../Cta'
import PageHeading from '../PageHeading'
import PricingTableList from '../PricingTable/PricingTableList'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServicesPage() {
  pageTitle('Service');

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <PageHeading
        title='Services'
        bgSrc='images/service_hero_bg.jpeg'
        pageLinkText='Services'
      />

      <Spacing lg='120' md='60' />

      <Div className="container">
        <Div className="row">

          <Div className="col-xl-6 col-lg-6 col-md-12">
            <Div className="service-box">
              <h3>Influencer Marketing</h3>
              <p>
                The fastest way to dominate social media feeds. Guaranteed thousands of views with a flat rate, built for smart companies.
              </p>
              <a href="/service/ui-ux-design" className="service-btn">Explore</a>
            </Div>
          </Div>

          <Div className="col-xl-6 col-lg-6 col-md-12">
            <Div className="service-box">
              <h3>Company</h3>
              <p>
                We create and run a content system that keeps your company visible, talked about, and top of mind basically, word of mouth on autopilot.
              </p>
              <a href="/service/reactjs-development" className="service-btn">Explore</a>
            </Div>
          </Div>

          <Div className="col-xl-6 col-lg-6 col-md-12">
            <Div className="service-box">
              <h3>Founder</h3>
              <p>
                If you want people to trust you, they need to see you. We help you build a strong personal brand on Instagram and LinkedIn, consistent content that actually makes you look like a leader.
              </p>
              <a href="/service/digital-marketing" className="service-btn">Explore</a>
            </Div>
          </Div>

          <Div className="col-xl-6 col-lg-6 col-md-12">
            <Div className="service-box">
              <h3>Website</h3>
              <p>
                Your digital home that turns attention into revenue. A high-conversion website built to make your brand look credible, modern, and impossible to ignore.
              </p>
              <a href="/service/technology" className="service-btn">Explore</a>
            </Div>
          </Div>

          <Div className="col-xl-6 col-lg-6 col-md-12">
            <Div className="service-box">
              <h3>Consultancy</h3>
              <p>
                Expert guidance for digital transformation, tech strategy, and business scaling.
              </p>
              <a href="/service/consultancy" className="service-btn">Explore</a>
            </Div>
          </Div>

          <Div className="col-xl-6 col-lg-6 col-md-12">
            <Div className="service-box">
              <h3>Creative Design</h3>
              <p>
                Branding, graphics, and creative digital visuals tailored for your business.
              </p>
              <a href="/service/creative-design" className="service-btn">Explore</a>
            </Div>
          </Div>

        </Div>
      </Div>

      <Spacing lg='150' md='80' />

      <Div className="container">
        <SectionHeading
          title='Providing best <br/>pricing for client'
          subtitle='Pricing & Packaging'
        />
        <Spacing lg='85' md='40' />
        <PricingTableList />
      </Div>

      <Spacing lg='125' md='55' />

      <TestimonialSlider />

      <Spacing lg='150' md='80' />

      <Div className="container">
        <Cta
          title='Let’s disscuse make <br />something <i>cool</i> together'
          btnText='Apply For Meeting'
          btnLink='/contact'
          bgSrc='/images/cta_bg.jpeg'
        />
      </Div>
    </>
  )
}
